import { memo } from 'react'
import { useI18n } from '../i18n/I18nContext'

interface FavoriteButtonProps {
  isFavorite: boolean
  onClick: () => void
  size?: 'small' | 'medium'
}

export const FavoriteButton = memo(function FavoriteButton({
  isFavorite,
  onClick,
  size = 'medium'
}: FavoriteButtonProps) {
  const { t } = useI18n()
  const sizeClass = size === 'small' ? 'favorite-btn-small' : 'favorite-btn-medium'
  const label = isFavorite ? t('buttons.favorite.remove') : t('buttons.favorite.add')

  return (
    <button
      className={`favorite-btn ${sizeClass} ${isFavorite ? 'favorite-active' : ''}`}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      {isFavorite ? '⭐' : '☆'}
    </button>
  )
})
